//
// ScrollAnchors.js -- auto scroll-to on clickesons
//
// Auto-initialization from elements
// --------------------------------------
// HTML:  <a href="#somewhere" class="... js-scrollAnchors">
//
// JS:    require('./ScrollAnchors').auto_add();
//
// Options:
//    data-scrollanchors-speed="<number>" -- override the global default
//                                           for this element
//    data-scrollanchors-offset="<number>" -- offset the target position
//                                            by <number> pixels
//    data-scrollanchors-set-history="true|false"  -- override the setting for set_history.
//                                                    case sensitive.
//
// Options set as data attributes take precedence over those
// set programmatically.
//
// This then allows us to alter the options on an element after
// initializing, just by updating the data attributes.
//
//
// Programmatic initialization
// --------------------------------------
// HTML:  <a href="#somewhere">
//
// JS:    var a_element = ~;
//        var ScrollAnchors = require('./ScrollAnchors');
//        ScrollAnchors.add(a_element);
//
//
// Global defaults
// --------------------------------------
// - Default is a speed of 1 (equivalent to 1000px/s)
// - Change the default everywhere on the current page with:
//     ScrollAchors.set_defaults({ speed: 2 });
// - Set_history: whether or not to push_state the #fragment
//

const Scr = require("./ScrollTo");

const defaults = {
  speed: 1,
  set_history: true,
};

function state() {
  if (!window.scroll_anchors_state) {
    window.scroll_anchors_state = {
      defaults,
    };
  }

  return window.scroll_anchors_state;
}

function get_data_options(el_toggle) {
  const opts = {};

  set_opt_if_present("data-scrollanchors-speed", "speed");
  set_opt_if_present("data-scrollanchors-offset", "offset");
  set_opt_if_present("data-scrollanchors-set-history", "set_history");

  if (opts.hasOwnProperty("speed")) {
    if (opts.speed.match(/^[1-9][0-9\.]*$/)) {
      opts.speed = parseFloat(opts.speed);
    } else {
      delete opts.speed;
    }
  }
  if (opts.hasOwnProperty("offset")) {
    if (opts.offset.match(/-?\d+/)) {
      opts.offset = parseFloat(opts.offset);
    } else {
      delete opts.offset;
    }
  }

  return opts;

  function set_opt_if_present(attrib, internal_name) {
    if (el_toggle.hasAttribute(attrib)) {
      opts[internal_name] = el_toggle.getAttribute(attrib);

      if (internal_name === "set_history") {
        opts[internal_name] = opts[internal_name] === "true";
      }
    }
  }
}

function cb_click(ev) {
  ev.preventDefault();
  const target_hash = this.getAttribute("href").substr(1);
  const target = document.getElementById(target_hash);

  const opts = { ...state().defaults, ...get_data_options(this) };

  if (target) {
    if (opts.set_history) {
      history.pushState(
        null,
        null,
        `${location.pathname}${location.search || ""}#${target_hash}`
      );
    }
    Scr.scroll_to_element(target, opts);
  }
}

var exp = {
  add(el_toggle) {
    el_toggle.addEventListener("click", cb_click);
  },
  auto_add() {
    const items = Array.from(
      document.getElementsByClassName("js-scrollAnchors")
    );
    items.forEach((item) => exp.add(item));
  },

  remove(el_toggle) {
    el_toggle.removeEventListener("click", cb_click);
  },
  auto_remove() {
    const items = Array.from(
      document.getElementsByClassName("js-scrollAnchors")
    );
    items.forEach(exp.remove);
  },

  set_defaults(def) {
    Object.assign(state().defaults, def);
  },
};

module.exports = exp;
